import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { MatTableDataSource, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.scss']
})
export class PracticeComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public practiceProgrammes=[];

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public getPracticeProgrammes(){
    this._practice.getPracticeProgrammes(this.practiceId).subscribe(
      res=>{
        this.practiceProgrammes=res;
      }
    );
  }

  ngOnInit() {
    this.getPractice();
    this.getPracticeProgrammes();
  }

  ngAfterViewInit(){

  }

}
